import React, { useRef, useState } from 'react';
import AddUnit from '../userApp/AddUnit';
import { useDeleteCleanerAppMutation, useGetcleanerappQuery } from './CleanerSlice';
import CleanerEdit from './CleanerEdit';
import Swal from 'sweetalert2';
import AddCleaner from './AddCleaner';
import SpinnerForPage from '../../components/spinner/SpinnerForPage';

const Cleaner = () => {
    const [editData, setEditData] = useState({});
    
    const {
        data: cleaner,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetcleanerappQuery("getcleanerapp");

    // console.log("cleaner",cleaner);


    //this code is  Delet button
    const [deleteCleanerApp] = useDeleteCleanerAppMutation();
    const deleteHandle = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Warning ! Action might affect user application",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Deleted!",
                    text: "Your file has been deleted.",
                    icon: "success"
                });
                deleteCleanerApp(id).unwrap();
            }
        });
    };

    // Edit 
    const refOpen = useRef();

    const editCleaner = (ID) => {
        refOpen.current.click();
        const data = cleaner.find(item => item.cleaner_id === ID);
        setEditData({ cleaner_id: data?.cleaner_id, name: data?.name, number: data?.number, ward_id_array: data?.ward_ids })
    }
    return (
        <>
            {isLoading && <SpinnerForPage />}
            <div className="container-fluid mt-5">
                <div className="d-flex justify-content-end mb-2">
                    <div className="text-right">
                        <AddCleaner />
                    </div>
                </div>

                <div className="card card-dark mt-4">
                    <div className="table-border-style">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead className="mobile-hidden">
                                    <tr className="text-left">
                                        <th scope="col">Sr. No.</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Number</th>
                                        <th scope="col">Ward</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cleaner?.map((index, e) => {
                                            return <tr key={index} className="mobile-hidden listData text-left fw-normal">
                                                <td>{e + 1}</td>
                                                <td>{index?.name}</td>
                                                <td>{index?.number}</td>
                                                <td>{index?.ward_number}</td>
                                                <td>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn dropdown-toggle p-2"
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                            style={{ border: 'none' }}
                                                        >
                                                            <i className="fas fa-ellipsis-v" style={{ color: 'gray' }}></i>
                                                        </button>
                                                        <ul className="dropdown_Box dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                            <li>
                                                                <div
                                                                    className="dropdown-item"
                                                                    onClick={() => editCleaner(index?.cleaner_id)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Edit
                                                                </div>
                                                                <div
                                                                    className="dropdown-item"
                                                                    onClick={() => deleteHandle(index?.cleaner_id)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Delete
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <CleanerEdit
                refOpen={refOpen}
                setEditData={setEditData}
                editData={editData}
            />
        </>
    );
}

export default Cleaner;
